import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const getHashRedirectPath = () => {
  const { hash } = window.location;

  if (!hash.startsWith('#/')) {
    return null;
  }

  return hash.slice(1);
};

const HashPathRedirect: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const redirectPath = getHashRedirectPath();

    if (!redirectPath) {
      return;
    }

    navigate(redirectPath, { replace: true });
  }, [navigate]);

  return null;
};

export default HashPathRedirect;
